<template>

<main class="py-12 space-y-12">
        <SectionsSectionIntro
            :images="sectionIntro.images"
            :title="sectionIntro.title"
            :teaser="sectionIntro.teaser"
            :text="sectionIntro.text"
        />

        <section>
            <div class="container grid lg:grid-cols-2 gap-8">
                <VideoPlayer
                    url="/videos/Sauerland2025_Nachhaltigkeit_720p.mp4"
                    name="Sauerland2025_Nachhaltigkeit2"
                />
            </div>
        </section>

        <section
            class="relative bg-cover bg-center dp-contentblock block-title py-largest dp-fsimg"
            style="background-image: url(/images/backgrounds/BQ4C5272.jpg);"
        >
            <div class="relative z-10 py-48 dp-pagebounds">
              <h2 class=" my-none py-large py-l-largest text-center text-white! js-fade-in is-added is-visible">
                    Bäume für die nächsten Generationen
                </h2>
            </div>
          <div class="absolute top-0 left-0 w-full z-10 pointer-events-none">
            <BrandWave :height="150" flip variant="trio"/>
          </div>
          <span class="brand-overlay is-duo is-reversed is-vertical noprint"/>
          <div class="absolute bottom-0 left-0 w-full z-10 pointer-events-none">
            <BrandWave :height="150" variant="trio"/>
          </div>
        </section>

        <section>
            <div class="container">
                <article class="dp-article">
                  <div class="sustainability-philosophy-columns lg:columns-2 gap-16">
                      <h2 class=" title text-sustainability!">
                            Verantwortung ist Teil unserer Philosophie
                        </h2>
                        <p class="article-teaser">
                            Nachhaltigkeit ist für uns mehr als nur eine Floskel, sondern auch Bestandteil unserer
                            Unternehmenskultur. Für jeden verwendeten Baum werden Neue in mindestens gleicher Anzahl
                            aufgeforstet!
                        </p>
                        <p style="text-align: left;">
                            Der Wald ist der wichtigste Co2 Speicher unserer Erde. Wer auf natürliche Ressourcen&nbsp;
                            zurückgreift und nachhaltig handelt, sorgt für das notwendige Gleichgewicht. Für jeden für
                            uns geschlagenen Baum werden neue Bäume angepflanzt. Und das nicht in Monokultur, sondern
                            als Mischwald, <span class="Apple-converted-space">da dieser deutlich resistenter gegenüber Umwelteinflüssen und Schädlingen ist. Diese Bäume wachsen mindestens 60 Jahre.&nbsp;</span>
                        </p>
                    </div>
                </article>
            </div>
        </section>

        <section class="dp-contentblock block-textimage image-fullsize">
            <article class="dp-article">
                <div class="px-4 mx-auto lg:px-0 lg:mx-0">
                    <div class="grid lg:grid-cols-2">
                        <div
                            class="min-h-88 bg-cover rounded-xl"
                            style="background-image: url(/images/backgrounds/AdobeStock_260724142.jpg);"
                        />
                        <div class="lg:pl-16 lg:pr-80 py-16 space-y-8 article-text js-fade-in is-added is-visible">
                            <div>
                              <h2 class=" text-sustainability!">
                                    Unsere Ressourcen spenden Wärme
                                </h2>
                                <p class="article-teaser">
                                    Was für andere Abfall ist, wird bei uns noch weiterverarbeitet.
                                </p>
                                <p>
                                    Die bei der Verarbeitung anfallenden Resthölzer und Späne werden gesammelt und in
                                    unserer Holzfeuerungsanlage thermisch verwertet. Das spart Ressourcen und ca. 60.000
                                    Liter Heizöl pro Jahr. Wir reduzieren damit die Co2-Emission um ca. 170.000 kg pro
                                    Jahr und heizen unseren kompletten Betrieb umweltbewusst, denn Holz verbrennt Co2
                                    neutral.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </article>
            <article class="dp-article">
                <div class="px-4 mx-auto lg:px-0 lg:mx-0">
                    <div class="grid lg:grid-cols-2">
                        <div class="lg:pl-80 lg:pr-16 py-16 space-y-8 order-2 lg:order-1">
                            <div>
                              <h2 class=" text-sustainability!">
                                    Papier, Rohstoffe und Licht - geht auch grün!
                                </h2>
                                <p class="article-teaser">
                                    Wir arbeiten stets daran, uns weiter zu verbessern, frei nach dem Motto: Da geht
                                    noch was! Unser soziales und ökologisches Bewusstsein fordert uns jeden Tag aufs
                                    Neue heraus.
                                </p>
                                <p>
                                    Durch die Verwendung von Recyclingpapier sparen wir gegenüber Frischfaserpapier bis
                                    zu 60 Prozent der Energie und bis zu 70 Prozent Wasser sowie Co2-Emissionen und
                                    Abfall. Dort, wo wir können, arbeiten wir komplett papierlos.
                                </p>
                                <p>
                                    Wir verzichten bewusst auf Kunststoffe wo es geht und verwenden nachhaltige
                                    Rohstoffe: Holz, HPL, Stahl, Edelstahl und Aluminium.
                                </p>
                                <p>
                                    Auch durch den Einsatz von LED Beleuchtung sparen wir ca. 40% der bisherigen Energie
                                    für Beleuchtung ein.
                                </p>
                                <p>
                                    Tragen auch Sie diesen Gedanken mit uns und entscheiden Sie sich für Sauerland
                                    Spielgeräte, um gemeinsam einen Beitrag zur Nachhaltigkeit und <strong>Entlastung
                                    der Umwelt</strong> zu leisten. Machen Sie mit – für unsere Kinder!
                                </p>
                            </div>
                        </div>
                        <div
                            class="order-1 min-h-88 lg:order-2 bg-cover rounded-xl"
                            style="background-image: url(/images/backgrounds/BQ4C3431.jpg);"
                        />
                    </div>
                </div>
            </article>
        </section>

        <section
            class="relative bg-cover bg-center dp-contentblock block-title py-largest dp-fsimg"
            style="background-image: url(/images/backgrounds/BQ4C1042.jpg);"
        >
          <span class="noprint"/>
            <div class="relative z-10 py-48 dp-pagebounds">
              <h2 class=" my-none py-large py-l-largest text-center text-white! js-fade-in is-added is-visible">
                    Die Digitalisierung ist Teil unserer grünen Zukunft!
                </h2>
            </div>
          <div class="absolute top-0 left-0 w-full z-10 pointer-events-none">
            <BrandWave :height="150" flip variant="trio"/>
          </div>
          <span class="brand-overlay is-duo is-reversed is-vertical noprint"/>
          <div class="absolute bottom-0 left-0 w-full z-10 pointer-events-none">
            <BrandWave :height="150" variant="trio"/>
          </div>
        </section>

        <section class="dp-contentblock block-textimage image-fullsize">
            <article class="dp-article">
                <div class="px-4 mx-auto lg:px-0 lg:mx-0">
                    <div class="grid lg:grid-cols-2">
                        <div
                            class="min-h-88 bg-cover"
                            style="background-image: url(/images/backgrounds/BQ4C4601.jpg);"
                        />
                        <div class="lg:pl-16 lg:pr-80 py-16 space-y-8 article-text js-fade-in is-added is-visible">
                            <div>
                              <h2 class=" text-sustainability!">
                                    Wir sagen „adieu“ zu unserem gedruckten Gesamtkatalog
                                </h2>
                                <p class="article-teaser">
                                    Hier bei Sauerland Spielgeräte ist das Thema Nachhaltigkeit Bestandteil unserer
                                    Unternehmenskultur. Aus diesem Grund sagen wir nach reichlich langer Überlegung
                                    „adieu“ zu unserem gedruckten Gesamtkatalog.
                                </p>
                                <p>
                                    Unser Produktsortiment können Sie sich weiterhin in unserem
                                    <NuxtLink :to="{name: 'categories'}">
                                        digitalen Produktkatalog
                                    </NuxtLink>
                                    oder in unserer Ideenwelt anschauen. Informationen
                                    zu gewünschten Artikeln können Sie sich direkt als PDF herunterladen, oder mit einem
                                    Klick (rechts neben dem Produktbild) „
                                    <NuxtLink :to="{name: 'wishlist'}">
                                        auf den Merkzettel
                                    </NuxtLink>
                                    “ packen, auf dem Sie alle Artikel sammeln und bei uns per
                                    Mail anfragen können.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </article>
            <article class="dp-article">
                <div class="px-4 mx-auto lg:px-0 lg:mx-0">
                    <div class="grid lg:grid-cols-2">
                        <div class="lg:pl-80 lg:pr-16 py-16 space-y-8 order-2 lg:order-1">
                            <div>
                                <p class="article-teaser">
                                    Aber warum die digitale Umstellung?
                                </p>
                                <p>
                                    Bei unseren gedruckten Katalogen haben wir schon auf eine Menge verzichtet, um
                                    möglichst sparsam mit natürlichen Ressourcen umzugehen - Denn die Herstellung von
                                    gedruckten Gesamtkatalogen verbraucht nicht nur eine Menge Papier und Energie für
                                    Druck, Transport und Verpackung!
                                </p>
                                <p>
                                    Bei Sauerland Spielgeräte machen sich unsere klugen Köpfe stetig Gedanken, wie wir
                                    unsere Produkte erneuern und verbessern können. Durch die Umstellung auf den
                                    digitalen Produktekatalog haben Sie den Vorteil, dass sich die angebotenen Produkte
                                    immer auf dem neusten Stand befinden.
                                </p>
                              <UButton
                                    :to="{name: 'categories'}"
                                    label="Zu unserem Shop"
                              />
                            </div>
                        </div>
                        <div
                            class="order-1 min-h-88 lg:order-2 bg-cover"
                            style="background-image: url(/images/backgrounds/BQ4C6241.jpg);"
                        />
                    </div>
                </div>
            </article>
        </section>
    </main>
</template>

<script setup lang="ts">
import VideoPlayer from '~/components/VideoPlayer.vue';

definePageMeta({
    path: '/Nachhaltigkeit',
});

const header = useState<{ title: string; subTitle: string }>(
    'header',
);
header.value = {
    title: 'Eine Welt',
    subTitle: 'voller Nachhaltigkeit',
};

const sectionIntro = {
    images: ['BQ4C5466.jpg', 'BQ4C5272.jpg', 'BQ4C4852.jpg'],
    title: 'Nachhaltigkeit - Denn Verantwortung liegt uns am Herzen',
    teaser: 'Bei unserer täglichen Arbeit legen wir nicht nur ganz besonderen Wert auf Sicherheit, Wartungsfreundlichkeit und Stabilität, sondern auch auf eine verantwortungsbewusste Umweltorientierung.',
    text: '<p>Das Erfolgsrezept von Sauerland Spielgeräte? Neben unseren innovativen Ideen, bringt uns das verantwortungsbewusste Handeln immer weiter voran; denn Nachhaltigkeit ist für uns nicht nur eine Floskel, sondern liegt uns am Herzen.</p>'
        + '<p>Wir glauben ebenso, dass unser Beitrag für die Umwelt nicht nur die Spielplatzgestaltung positiv beeinflusst, sondern die Lebenssituation von Kindern verbessert und das Spielen spielwert macht.</p>'
        + '<p>Weitere spannende Infomationen über unseren Beitrag zur Nachhaltigkeit können Sie sich <a target="_blank" href="/pdf/Sauerland-Spielgera%CC%88te_Datenblatt-FSC_030321_Ansicht-1.pdf"><strong>hier</strong></a> herunterladen.</p>',
};
</script>

<style scoped>
.sustainability-philosophy-columns > * {
  /* Keep each heading/paragraph intact within one column. */
  break-inside: avoid;
  -webkit-column-break-inside: avoid;
  page-break-inside: avoid;
}

</style>
